document.addEventListener("DOMContentLoaded", function() {
  // local variables
  let pageIsDesktop = window.innerWidth >= 1024;

  function initCustomVideo(video, index) {
    // reject videos expected to be fully loaded at first, with native autoplay, or already initialized
    if (video.preload === "auto" || video.autoplay || video.playbackReady) return;
    video.playerId = video.id ?? index;
    // force first frame from video by playing it once
    setPlay(video);
    video.addEventListener("play", handleFirstTimePlayed);
    // wait for video to nearly-fully load
    video.addEventListener("canplaythrough", handlePlaybackReady);
  }
  window.initCustomVideo = initCustomVideo;

  function handleFirstTimePlayed(event) {
    const video = event.currentTarget;
    video.firstFramePlayed = true;
    setPause(video);
    // remove the handler since its not necessary anymore
    video.removeEventListener("play", handleFirstTimePlayed);
  }

  function handlePlaybackReady(event) {
    const video = event.currentTarget;
    video.playbackReady = true;
    // force autoplay on mobile or videos with no hover effect
    if (!pageIsDesktop || !video.classList.contains("play-on-hover")) {
      setPlay(video);
    }
    
    if (!video.classList.contains("play-on-hover")) return;

    const parent = video.closest(".video-parent");
    if (parent) {
      applyPlaybackOnHover(parent, video);
    } else {
      applyPlaybackOnHover(video, video);
    }
    // remove the handler since its not necessary anymore
    video.removeEventListener("canplaythrough", handlePlaybackReady);
  }

  function applyPlaybackOnHover(trigger, video) {
    trigger.addEventListener("mouseenter", function (event) {
      if (!pageIsDesktop) return;
      setPlay(video);
    });
    trigger.addEventListener("mouseleave", function (event) {
      if (!pageIsDesktop) return;
      setPause(video);
    });
  }

  function setPlay(video) {
    video.play();
  }

  function setPause(video) {
    video.pause();
    video.currentTime = 0;
  }

  // responsive playback on hover
  let debounceTimeout;
  window.addEventListener("resize", function (event) {
    clearTimeout(debounceTimeout);
    debounceTimeout = setTimeout(togglePlayback, 500);
  });
  function togglePlayback() {
    if (window.innerWidth >= 1024) {
      // When the page is on desktop find the videos that should play on hover and attempt to pause immediately
      if (!pageIsDesktop) {
        pageIsDesktop = true;
        const videos = document.querySelectorAll("video.rdh-video");
        videos.forEach(video => {
          if (video.playbackReady === undefined || !video.classList.contains("play-on-hover")) return;
          setPause(video);
        });
      }
    } else {
      // When the page is not on desktop find the videos that should play on hover and resume the playback
      if (pageIsDesktop) {
        pageIsDesktop = false;
        const videos = document.querySelectorAll("video.rdh-video");
        videos.forEach(video => {
          if (video.playbackReady === undefined || !video.classList.contains("play-on-hover")) return;
          setPlay(video);
        });
      }
    }
  }
});